export class ServerError {
  field_name: string;
  values: string[] = [];

  constructor(field_name: string, values: string[]) {
    this.field_name = field_name;
    this.values = values;
  }
}
